import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator, IStorageLocal } from "namirasoft-core";
import { ChatInferencerType, ChatRow, NamirasoftInferenceMetaDatabase } from "namirasoft-inference";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, FloatFormatter, IDFormatter, IntegerFormatter, NSColumn, NSTable, StringFormatter, TableColumnInfo } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import { InferenceRoutes } from "../InferenceRoutes";

interface ChatListProps extends NSARouterMakerResult, InferenceRouterProps
{
    inferencer_type: ChatInferencerType;
    inferencer_id: string;
}

interface ChatListState
{
    columns: TableColumnInfo[] | null;
}

export default class ChatList extends Component<ChatListProps, ChatListState>
{
    override state: ChatListState = { columns: null };

    private Table_Ref = createRef<NSTable<ChatRow>>();

    override componentDidMount(): void
    {
        this.setState({ columns: this.buildColumns() });
    }

    override componentDidUpdate(prev: ChatListProps): void
    {
        if (prev.inferencer_id !== this.props.inferencer_id || prev.inferencer_type !== this.props.inferencer_type)
            this.Table_Ref.current?.reload(null, null);
    }

    private buildColumns(): TableColumnInfo[]
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        let inference = new NamirasoftInferenceMetaDatabase(this.props.account.token_manager, console.error);
        let chat = inference.tables.chat;
        return [
            BaseColumnFormatter.getColumn(chat.columns.id, new IDFormatter(namirasoft, null)),
            BaseColumnFormatter.getColumn(chat.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
            BaseColumnFormatter.getColumn(chat.columns.inferencer_type, new EnumFormatter()),
            BaseColumnFormatter.getColumn(chat.columns.inferencer_id, new IDFormatter(namirasoft, new IStorageLocal())),
            BaseColumnFormatter.getColumn(chat.columns.name, new StringFormatter()),
            BaseColumnFormatter.getColumn(chat.columns.total_token, new IntegerFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.total_token_input, new IntegerFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.total_token_output, new IntegerFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.total_cost, new FloatFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.total_cost_input, new FloatFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.total_cost_output, new FloatFormatter(), "Total"),
            BaseColumnFormatter.getColumn(chat.columns.created_at, new DateTimeFormatter()),
            BaseColumnFormatter.getColumn(chat.columns.updated_at, new DateTimeFormatter()),
        ];
    }

    private getRows = async (page: number, size: number): Promise<{ rows: ChatRow[]; count: number }> =>
    {
        if (!this.props.inferencer_id)
            return { rows: [], count: 0 };
        let inference = new NamirasoftInferenceMetaDatabase(this.props.account.token_manager, console.error);
        let chat = inference.tables.chat;
        let filters: FilterItem[] = [
            new FilterItem(chat, chat.columns.inferencer_type, false, FilterItemOperator.all.equals, this.props.inferencer_type),
            new FilterItem(chat, chat.columns.inferencer_id, false, FilterItemOperator.all.equals, this.props.inferencer_id),
        ];
        return await this.props.servers.inference.chat.List(filters, page, size, [], null);
    };

    override render()
    {
        let { columns } = this.state;
        return (
            <NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", flexGrow: 1 }}>
                    <NSTable<ChatRow>
                        ref={this.Table_Ref}
                        name="chat-list"
                        checkbox={false}
                        columns={columns ?? this.buildColumns()}
                        getRows={this.getRows}
                        getRowKey={(row) => row.value.id}
                        onRowClick={(_e, row) => this.props.url.redirect(InferenceRoutes.ChatView(row.value.id), {})}
                        ui={{ pagination: true, button_panel: true }}
                    />
                </div>
            </NSColumn>
        );
    }
}